import { SingleFeaturedCard } from "./singleFeaturedCard";
import IntegrationImage from "../../../assets/icons/business/easy-integration-icon.svg";
import Cube3d from "../../../assets/icons/business/3dcube.svg";
import CircleCoinStack from "../../../assets/icons/business/circle-stack.svg";


export const BusinessFeaturedCards = () => {
    return (
        <div className="bg-white px-4 pb-[4rem] pt-[10rem] md:px-10 lg:px-10 xl:px-32 ">

            <div className="flex flex-col md:flex-row gap-[2rem]">

                <SingleFeaturedCard
                imageSource={IntegrationImage}
                title="Easy Integration"
                text="Quickly send payment links via email, text, or social media—no website or shopping cart needed."                
                />

                <SingleFeaturedCard
                imageSource={CircleCoinStack}
                title="Invoicing Made Simple"
                text="Easily generate links for recurring payments or one-time invoices, improving cash flow and reducing payment delays."                
                />

                <SingleFeaturedCard
                imageSource={Cube3d}
                title="Secure Transactions"
                text="Built-in fraud protection features ensure secure transactions and minimize chargebacks."            
                />
            </div>
        
        </div>
    )
}